import {Component, EventEmitter, HostListener, Inject, Input, Optional, Output} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {MAT_DIALOG_DATA, MatDialogRef} from '@angular/material/dialog';
import {compressFile} from '../../shared/utils/compressImage';

@Component({
  selector: 'app-scan-doc-webcam',
  templateUrl: './scan-doc-webcam.component.html',
  styleUrl: './scan-doc-webcam.component.scss'
})
export class ScanDocWebcamComponent {
  @Input() labelKey: string;
  @Input() disabled = false;
  @Input() hasValue = false;
  @Output() captured = new EventEmitter<string>();

  showWebcam = false;
  fileName: string = null;
  inputForm: FormGroup;

  get isDialog(): boolean {
    return !!this.dialogRef;
  }

  constructor(private formBuilder: FormBuilder,
    @Optional() private dialogRef: MatDialogRef<ScanDocWebcamComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) data: {labelKey?: string}) {
    if(data?.labelKey) this.labelKey = data.labelKey;
    this.inputForm = this.formBuilder.group({
      webcam_input: ['']
    });
  }

  @HostListener('keydown.enter', ['$event'])
  onEnterKey(event: KeyboardEvent) {
    if(!this.showWebcam && this.isDialog && !this.disabled) {
      event.preventDefault();
      event.stopPropagation();
      this.openCamera();
    }
  }

  @HostListener('keydown.escape', ['$event'])
  onEscapeKey(event: KeyboardEvent) {
    if(this.showWebcam) { // Close camera if open, otherwise close dialog
      event.preventDefault();
      event.stopPropagation();
      this.closeCamera();
    } else if(this.isDialog) {
      event.preventDefault();
      event.stopPropagation();
      this.closeDialog();
    }
  }

  closeDialog() {
    this.dialogRef?.close(null);
  }

  openCamera() {
    if(this.disabled) return;
    this.showWebcam = true;
  }

  closeCamera() {
    this.showWebcam = false;
  }

  onDeleteFile() {
    if(this.disabled) return;
    this.hasValue = false;
    this.fileName = null;
    this.inputForm.get('webcam_input')?.setValue('');
    this.inputForm.get('webcam_input')?.markAsPristine();
    this.inputForm.get('webcam_input')?.markAsUntouched();
    this.captured.emit(null);
  }

  async onCaptured(base64Image: string) {
    if(!base64Image) return;
    this.hasValue = true;
    this.fileName = (this.labelKey || 'capture') + '_webcam_capture.jpg';
    // Convert base64 to File
    const byteString = atob(base64Image.split(',')[1]);
    const arrayBuffer = new ArrayBuffer(byteString.length);
    const intArray = new Uint8Array(arrayBuffer);
    for(let i = 0; i < byteString.length; i++) intArray[i] = byteString.charCodeAt(i);
    const file = new File([intArray], this.fileName, {type: 'image/jpeg'});
    const compressedB64 = await compressFile(file, 0.5);
    this.captured.emit(compressedB64);
    this.dialogRef?.close(compressedB64);
    this.closeCamera();
  }

  async onFileSelected(event: Event) {
    const input = event.target as HTMLInputElement;
    const file = input?.files?.[0];
    if(!file) return;
    this.hasValue = true;
    this.fileName = file.name;
    const compressedB64 = await compressFile(file, 0.5);
    this.captured.emit(compressedB64);
    this.dialogRef?.close(compressedB64);
    input.value = '';
  }
}
